export const korTheme = {
    backgroundColor: "#FF5B02",
    bottomNavTextActive: "#fff",
    bottomNavText: "#fff",
    org: "#FF5B02",
    orgText: "#fff",
    backCont : "linear-gradient(120deg, rgba(20,39,71,1) 0%, rgba(49,95,173,1) 100%)",
    saleeIcon : "none",
  };
  
  export const engTheme = {
    backgroundColor: "#FF5B02",
    bottomNavTextActive: "#fff",
    bottomNavText: "#fff",
    org: "#FF5B02",
    orgText: "#fff",
    backCont : "linear-gradient(120deg, rgba(20,39,71,1) 0%, rgba(49,95,173,1) 100%)",
    saleeIcon : "none",
  };

  export const vietTheme = {
    backgroundColor: "#BE9C26",
    bottomNavTextActive: "#fff",
    bottomNavText: "#fff",
    org: "#BE9C26",
    orgText: "#fff",
    backCont : "linear-gradient(120deg, rgba(165,25,49,1) 0%, rgba(45,42,74,1) 100%)",
    saleeIcon: "none",
  };

  export const thaiTheme = {
    backgroundColor: "#175246",
    bottomNavTextActive: "#fff",
    bottomNavText: "#fff",
    org: "#175246",
    orgText: "#fff",
    backCont : "linear-gradient(120deg, rgba(255,255,0,1) 0%, rgba(218,37,29,1) 100%)",
    saleeIcon: "none",
  };
  
  export const theme = {
    korTheme,
    engTheme,
    vietTheme,
    thaiTheme
  };